import { useState } from "react";

import data from "../data";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import About from "../components/About";
import Portfolio from "../components/Portfolio";
import Client from "../components/Client";
import Blog from "../components/Blog";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const App = () => {
  const [myInfo] = useState(data);

  return (
    <div>
      <Navbar />
      <Header {...myInfo} />
      <About {...myInfo} />
      <Portfolio {...myInfo} />
      <Client {...myInfo} />
      <Blog {...myInfo} />
      <Contact {...myInfo} />
      <Footer {...myInfo} />
    </div>
  );
};

export default App;
